import React, { useState, useEffect, useContext } from "react";
import "../css/signIn.css";
import signInImg from "../img/signin-img.png";
import axiosHttp from "../config/axios.interceptor";
import { useDispatch } from "react-redux";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import {
  base_url,
  errorResponseMessage,
  httpHeaderConfig,
  sociallogConfig,
} from "../shared/const.prop";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import ForgotPasswordModal from "../components/ForgotPasswordModal";
import OtpVerification from "../components/OtpVerification";
import ResetPasswordModal from "../components/ResetPasswordModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { calendarReducerConstant } from "../store/reducerConstant";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";

const SignInForm = () => {
  const appContext = useContext(AppContext);
  const { login, logout } = useContext(AuthContext);
  const dispatch = useDispatch();
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#^$%!])[A-Za-z\d@#^$%!]{8,}$/;
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [err, setErr] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);
  const [isForgotDisabled, setIsForgotDisabled] = useState(false);
  const [isOtpDisabled, setIsOtpDisabled] = useState(false);
  const [isResetDisabled, setIsResetDisabled] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  useEffect(() => {
    localStorage.clear();
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleInputChange = (e) => {
    setErr(false);
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validate = () => {
    if (!emailRegex.test(formData.email)) {
      setErr("Enter a valid email");
      return false;
    } else if (!passwordRegex.test(formData.password)) {
      setErr(
        "Password must be 8 characters and include at least one lowercase letter, one uppercase letter, one number, and one special character"
      );
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (validate()) {
    setIsDisabled(true);
    try {
      const loginSubmitData = await axiosHttp.post(
        `login`,
        JSON.stringify({
          email: formData.email,
          password: btoa(formData.password),
        })
      );
      if (loginSubmitData.status === 200) {
        localStorage.setItem(
          "token",
          loginSubmitData?.data?.success?.token || null
        );
        localStorage.setItem(
          "userId",
          loginSubmitData?.data?.userProfile?.userId
        );
        localStorage.setItem(
          "zone",
          loginSubmitData?.data?.userProfile?.zone?.[0]
        );
        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());
        setTimeout(() => {
          login(loginSubmitData?.data?.userProfile || null);

          setIsDisabled(false);
        }, 500);
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        setIsDisabled(false);
      }
    } catch (e) {
      if (e.response.status !== 401) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      } else if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        setErr(errorResponseMessage(e));
        setIsDisabled(false);
      }
      setIsDisabled(false);
    }
    // }
  };

  const handleForgotPasswordSubmit = async (email) => {
    setIsForgotDisabled(true);
    try {
      const emailSendHandler = await axiosHttp.post(`forget-password`, {
        email: email,
      });
      if (emailSendHandler.status === 201) {
        localStorage.setItem("userId", emailSendHandler.data.userId);
        setForgotEmail(email);
        // setTimeout(() => {
        setIsForgotPasswordOpen(false);
        setIsOtpModalOpen(true);
        setIsForgotDisabled(false);
        // }, 200);
      } else {
        setIsForgotDisabled(false);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setIsForgotPasswordOpen(false);
      setIsForgotDisabled(false);
    }
  };

  const handleOtpSubmit = async (otp) => {
    setIsOtpDisabled(true);
    try {
      const submitData = await axios.post(
        `${base_url}verify-forgot-code`,
        {
          code: otp,
          userId: localStorage.getItem("userId"),
        },
        {
          headers: httpHeaderConfig,
        }
      );
      if (submitData.status === 200 || submitData.status === 201) {
        setTimeout(() => {
          localStorage.setItem(
            "resetPasswordConfirm",
            JSON.stringify({
              userId: localStorage.getItem("userId"),
              otp: `${otp}`,
            })
          );
          setIsOtpModalOpen(false);
          setIsResetPasswordOpen(true);
        }, 500);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        setIsOtpDisabled(false);
        return;
      }
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(error),
      });
      setIsOtpDisabled(false);
    }
  };

  const handlePasswordResetSubmit = async (newPassword) => {
    setIsResetDisabled(true);
    try {
      const submitData = await axios.post(
        `${base_url}verify-code`,
        {
          password: btoa(newPassword),
          code: JSON.parse(localStorage.getItem("resetPasswordConfirm")).otp,
          userId: localStorage.getItem("userId"),
        },
        {
          headers: httpHeaderConfig,
        }
      );
      if (submitData.status === 201) {
        setIsResetDisabled(false);
        setIsResetPasswordOpen(false);
        setTimeout(() => {
          appContext.updateModalType("resetSuccess");
        }, 200);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        setIsResetDisabled(false);
        return;
      }
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(error) + ".Please try again.",
      });
      setIsResetDisabled(false);
    }
  };

  const resendOtpHandler = async () => {
    try {
      const emailSendHandler = await axiosHttp.post(`forget-password`, {
        email: forgotEmail,
      });
      if (emailSendHandler.status === 201) {
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: "OTP resent again",
        });
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setIsForgotPasswordOpen(false);
      setIsForgotDisabled(false);
    }
  };

  // const handleLoginChange = () => {
  // const width = 500;
  // const height = 600;
  // const left = window.screen.width / 2 - width / 2;
  // const top = window.screen.height / 2 - height / 2;
  // const params = `width=${width},height=${height},left=${left},top=${top}`;
  // let url = new URL(sociallogConfig.oauthUrl);
  // url.searchParams.append("response_type", "code");
  // url.searchParams.append("client_id", sociallogConfig.clientId);
  // url.searchParams.append("redirect_uri", sociallogConfig.redirectUrl);
  // url.searchParams.append("scope", sociallogConfig.scope);
  // const popup = window.open(url, "LinkedIn Login", params);
  // const intervalId = setInterval(() => {
  //   try {
  //     if (popup.location.href.startsWith(sociallogConfig.redirectUrl)) {
  //       const code = new URLSearchParams(popup.location.search).get("code");
  //       popup.close();
  //       clearInterval(intervalId);
  //       loginWithCode(code);
  //     }
  //   } catch (error) {}
  // }, 500);
  // };

  const handleLoginChange = useGoogleLogin({
    onSuccess: (tokenResponse) => loginWithCode(tokenResponse?.access_token),
    onError: (error) => {
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
    },
  });

  const loginWithCode = async (code) => {
    appContext.updateLoaderState(true);
    try {
      const loginWithGoogle = await axiosHttp.post(`login/google`, {
        token: code,
      });
      if (loginWithGoogle.status === 200) {
        localStorage.setItem(
          "token",
          loginWithGoogle?.data?.success?.token || null
        );

        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());
        setTimeout(() => {
          login(loginWithGoogle?.data?.userProfile || null);
          appContext.updateLoaderState(false);
        }, 500);
      } else {
        appContext.updateNotificationState({
          show: true,
          message: "Invalid username/password",
          type: "error",
        });
        appContext.updateLoaderState(false);
      }
    } catch (e) {
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        appContext.updateLoaderState(false);
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
      appContext.updateLoaderState(false);
    }
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="signin-page">
        <div className="signin-wrapper">
          <div className="left-side">
            <h1>Welcome Back to Upskillmeet!</h1>
            <p>Please sign in to continue to your account.</p>
            {err && <p className="error form-error">{err} </p>}
            <form className="signin-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email ID</label>
                <div className="input-group">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="jdoe@example.com"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="input-group eye-pass-group">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Password"
                    required
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="password-toggle"
                  >
                    {passwordVisible ? "🙈" : "👁️"}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="signin-btn"
                disabled={isDisabled}
              >
                {isDisabled ? "Signing in..." : "Sign In"}
              </button>

              <div className="forgot-password-link">
                <a href="#" onClick={() => setIsForgotPasswordOpen(true)}>
                  Forgot Password?
                </a>
              </div>

              <div className="signup">
                Don't have an account? <a href="/signup-options">Sign Up</a>
              </div>
            </form>
            <div className="divider">or</div>
            <div className="signup-options">
              <button
                className="linkedin-signup-btn"
                onClick={handleLoginChange}
              >
                <FontAwesomeIcon icon={faGoogle} className="linkedin-icon" />
                Continue with Google
              </button>
            </div>
          </div>

          {/* <div className="right-side">
        <img
          src={signInImg}
          alt="Your Placeholder"
          className="placeholder-image"
        />
      </div> */}
          <ForgotPasswordModal
            isOpen={isForgotPasswordOpen}
            onClose={() => setIsForgotPasswordOpen(false)}
            onSubmit={handleForgotPasswordSubmit}
            isForgotDisabled={isForgotDisabled}
          />

          <OtpVerification
            isOpen={isOtpModalOpen}
            onClose={() => setIsOtpModalOpen(false)}
            onSubmit={handleOtpSubmit}
            isOtpDisabled={isOtpDisabled}
            resendOtpHandler={resendOtpHandler}
            title="You have got mail"
            description="Please check your email for OTP"
            btnTxt="Continue"
          />

          <ResetPasswordModal
            isOpen={isResetPasswordOpen}
            onClose={() => setIsResetPasswordOpen(false)}
            onSubmit={handlePasswordResetSubmit}
            isResetDisabled={isResetDisabled}
          />
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default SignInForm;
